/**
 * Fallback constants for visuals whose real value should come from a tool.
 *
 * These are NOT the source of truth. A meter's threshold is a product decision
 * that belongs in the backend; until a tool exposes it, the number lives here
 * so there is exactly one place to fix — never inlined in a component, where
 * it would have to be hunted down across nine files later.
 *
 * Each entry records what should replace it.
 */
export const METER_THRESHOLDS = {
  // TODO replace with a tool-supplied value (no tool exposes it today).
  // Deliverability is judged against a threshold, never against 100%.
  deliverability: { value: 95, unit: "%", label: "healthy above 95%" },
  bounce_rate: { value: 3, unit: "%", label: "keep below 3%", inverse: true },
  daily_limit: { value: 100, unit: "", label: "daily send limit" },
  linkedin_daily: { value: 100, unit: "", label: "LinkedIn daily limit" }
};

/**
 * Resolve a meter threshold. `block.threshold` (tool-supplied) always wins;
 * the fallback is only consulted when the agent could not supply one.
 * Returns null when neither exists — the meter then refuses to render rather
 * than inventing a denominator.
 */
export const resolveThreshold = (thresholdFromBlock, kind) => {
  if (thresholdFromBlock && thresholdFromBlock.value != null) {
    return { ...thresholdFromBlock, source: "tool" };
  }
  const fallback = METER_THRESHOLDS[kind];
  return fallback ? { ...fallback, source: "fallback" } : null;
};

export default METER_THRESHOLDS;
